export default {
  go_to_questionnaire: "Ir al cuestionario",
  studea_manager: {
    confirm_duplication: "¿Seguro que quiere duplicar estos datos?",
    data_duplicated_success: "Datos duplicados correctamente",
    delete_session_confirmation: "¿Confirma que quiere eliminar este periodo?",
    delete_referential_confirmation: "¿Confirma que quiere eliminar esta referencia?",
    navigation: {
      general: "General",
      modules: "Módulos",
      pilotage: "Dirección",
    },
    triadUser: {
      title: "usuario secundario",
    },
    moderation: {
      title: ({ plural }) => plural(["Denuncia", "Denuncias"]),
      censor: "Censurar",
      restore: "Anular la denuncia",
      show: "Ver",
      show_censor: "Ver los mensajes censurados",
      show_message: "Ver los mensajes para moderar",
      file: "Archivo",
      modal_title: "Conversación",
      alert_title: "Censurar un mensaje",
      alert_sub_title: "¿Quiere censurar o anular la denuncia de este mensaje?",
      censor_success: "Mensaje censurado correctamente",
    },
    home: {
      title: ({ plural }) => plural(["Configuración de la ", "Configuración del "]),
      page_title: "Configuración",
    },
    trainingSkillCategory: {
      title: ({ plural }) => plural(["Bloque de competencias", "Bloques de competencia"]),
      block: ({ plural }) => plural(["Bloque", "Bloques"]),
    },
    trainingSkillCriticalLearning: {
      title: ({ plural }) => plural(["Aprendizaje crítico", "Aprendizajes críticos"]),
      level_column: "Nivel",
      content_column: "Aprendizaje crítico",
      level: ({ named }) => `Nivel ${named("n")}`,
      empty:
        "No hay aprendizajes críticos definidos para esta competencia. Use la IA para generarlos o edite la competencia para añadirlos manualmente.",
      empty_action: "Editar la competencia",
      collapse: "Ocultar los aprendizajes críticos",
      expand: "Mostrar los aprendizajes críticos",
      update_success: "Aprendizaje crítico actualizado correctamente",
      update_error: "Error al actualizar el aprendizaje crítico",
    },
    questionnaire: {
      title: ({ plural }) => plural(["Cuestionario", "Cuestionarios"]),
      list: {
        title: "Configuración de los cuestionarios",
      },
      questionnaire_already_signed: "Este cuestionario ya se ha firmado",
      duplicate_year: {
        title: "Duplicar al año siguiente",
        confirm: "¿Desea duplicar todos los cuestionarios de este año al año siguiente?",
        success: "Los cuestionarios han sido duplicados al año siguiente",
      },
      start_date: ({ named }) => `Fecha de acceso ${named("profile")} - del`,
      end_date: "al",

      finish: {
        title: "Finalizar mi configuración",
      },
      empty_title: "Para empezar, añada un título, una pregunta o una tabla de respuesta",
      add_question: "Añadir una pregunta",
      add_title: "Añadir un título",
      add_question_cluster: "Añadir una tabla de preguntas",
      required: "Obligatorio",
      question_settings: "Configuración de la pregunta",
      question_access: "Configuración de los accesos",
      cluster_settings: "Configuración de la tabla",
      remove_question: "Eliminar la pregunta",
      remove_cluster: "Eliminar la tabla",
      remove_title: "Eliminar el título",
      duplicate_cluster: "Duplicar la tabla",
      duplicate_question: "Duplicar la pregunta",
      tip: "Indicador de función",
      display_mode: "Tabla de respuesta",
      save: "Registrar",
      save_success: "Cuestionario guardado correctamente",
      save_error: "Se ha producido un error en el almacenamiento",
      missing_error:
        "Atención, faltan algunos derechos de acceso, títulos de preguntas, tipos de pregunta o columnas de respuesta en las grillas de cuestionario.",
      informations: "Informaciónes",
      deadlines_reminders: "Fechas límite y recordatorios",
      advanced_parameter: "Configuración avanzada",
      company_visit: "Visita a la empresa",
      settings: "Parámetros",
      summary: "Resumen",
      add_column: "Añadir una columna",
      add_row: "Añadir una fila",
      row_settings: "¿Quién lo rellena?",
      skill_settings: "Gestionar las competencias relacionadas",
      access_missing: "Faltan derechos de acceso para esta pregunta",
      title_missing: "Debe introducir un título para esta pregunta",
      value_title_missing: "Vous devez renseigner un titre pour cette valeur",
      duplicate_row: "Duplicar la línea",
      remove_row: "Eliminar la línea",
      remove_column: "Eliminar la columna",
      empty_line: "Línea sin título",
      add_skill: "Añadir esta competencia",
      skill_category_name: "Categoría",
      skill_name: "Nombre",
      coefficient: "Coeficiente",
      mission: "Misión",
      activity: "Actividad",
      mission_block_title: "Misiones del contrato",
      mission_preview_summary_example: "3 en curso · 1 finalizada · 1 archivada",
      mission_summary_counts: "{inProgress} en curso · {completed} finalizada(s) · {archived} archivada(s)",
      mission_example_name: "Desarrollo de una nueva aplicación interna",
      mission_progress_label: "Progreso",
      mission_objectives_label: "Objetivos para este periodo",
      mission_objectives_placeholder: "Describa los objetivos a alcanzar para este periodo",
      item_filter_display_label: "Mostrar",
      item_filter_completion_label: "Completitud",
      item_filter_chronology_label: "Cronología",
      mission_filter_all: "Todas",
      mission_filter_in_progress: "En curso",
      mission_filter_completed: "Finalizadas",
      mission_filter_archived: "Archivadas",
      item_sort_label: "Ordenar",
      mission_sort_start_date: "Fecha de inicio",
      mission_sort_end_date: "Fecha de fin",
      mission_comment_label: "Comentario",
      mission_comment_placeholder: "Añada un comentario (opcional)",
      mission_completed_badge: "Finalizada",
      mission_archived_badge: "Archivada",
      mission_filter_results_count: "{count} misión(es) mostrada(s)",
      mission_archive_action: "Archivar",
      mission_archive_modal_title: "Archivar una misión",
      mission_archive_warning:
        "El archivado oculta la misión de la lista activa. Sigue siendo consultable a través del filtro «Archivadas». Esta acción es reversible.",
      mission_archive_reason_label: "Motivo del archivado",
      mission_archive_reason_placeholder:
        "Explique por qué se archiva esta misión (cambio de alcance, redundancia, reorientación del contrato...)",
      mission_archive_submit: "Archivar la misión",
      mission_archive_success: "La misión se ha archivado correctamente",
      mission_unarchive_action: "Desarchivar",
      mission_unarchive_confirm_title: "¿Desarchivar esta misión?",
      mission_unarchive_confirm_text: "La misión volverá a ser visible en la lista de misiones en curso.",
      mission_unarchive_success: "La misión se ha desarchivado correctamente",
      mission_edit_action: "Modificar",
      mission_edit_modal_title: "Modificar una misión",
      mission_edit_confirm_title: "¿Confirmar la modificación?",
      mission_edit_confirm_subtitle:
        "Esta modificación se repercutirá en la misión del contrato y será visible en el resumen global.",
      mission_edit_success: "La misión se ha modificado correctamente",
      mission_add_action: "Añadir una misión",
      mission_add_label: "Añadir",
      mission_add_modal_title: "Añadir una misión",
      mission_add_success: "La misión se ha creado correctamente",
      mission_history_action: "Ver el historial de objetivos",
      mission_history_modal_title: "Historial de objetivos",
      mission_history_empty: "Aún no se ha definido ningún objetivo para esta misión.",
      mission_history_error: "Se ha producido un error al cargar el historial.",
      mission_history_defined_by: "Definido por {name} ({profile}) · {date}",
      history_profile_apprentice: "Aprendiz",
      history_profile_tutor: "Tutor",
      history_profile_apprenticeMaster: "Maestro de aprendizaje",
      history_profile_studeaManager: "Gestor",
      activity_block_title: "Actividades del contrato",
      activity_preview_summary_example: "2 en curso · 1 finalizada · 1 archivada",
      activity_example_name: "Redacción de un informe de análisis",
      activity_sort_start_date: "Fecha de inicio",
      activity_sort_end_date: "Fecha de fin",
      activity_filter_results_count: "{count} actividad(es) mostrada(s)",
      activity_add_action: "Añadir una actividad",
      activity_filter_all: "Todas",
      activity_filter_ongoing: "En curso",
      activity_filter_to_complete: "Por completar",
      activity_filter_completed: "Completas",
      activity_filter_certified: "Certificadas",
      activity_filter_archived: "Archivadas",
      activity_to_certify_badge_label: "Por certificar",
      activity_to_certify_alert: "Tiene {count} actividad(es) por certificar. Mostrar las actividades completas.",
      activity_filter_finished: "Finalizadas",
      activity_temporal_ongoing: "En curso",
      activity_temporal_finished: "Finalizada",
      activity_workflow_validated: "Validada",
      activity_workflow_certified: "Certificada",
      activity_workflow_cancelled: "Cancelada",
      activity_step_creation: "Creación",
      activity_step_description: "Descripción",
      activity_step_analysis: "Análisis",
      activity_step_skills: "Competencias",
      activity_step_validation: "Validación",
      activity_step_badge: "Etapa {number} - {label}",
      activity_stepper_label: "Progreso de la actividad",
      activity_step_state_done: "Etapa {number} de {total}: {label}, completada",
      activity_step_state_current: "Etapa {number} de {total}: {label}, en curso",
      activity_step_state_todo: "Etapa {number} de {total}: {label}, pendiente",
      activity_level_of_achievement: "{percent}% completado",
      activity_level_of_achievement_aria: "Nivel de completitud de la actividad: {percent}%",
      activity_edit_action: "Modificar",
      activity_certify_action: "Certificar",
      activity_view_action: "Consultar",
      activity_end_date_action: "Indicar la fecha de fin",
      activity_archive_action: "Archivar",
      activity_archive_modal_title: "Archivar la actividad",
      activity_archive_warning:
        "La actividad archivada ya no será visible para los tutores. Seguirá siendo consultable por usted.",
      activity_archive_submit: "Archivar",
      activity_archive_success: "Actividad archivada",
      activity_unarchive_action: "Desarchivar",
      activity_unarchive_confirm_title: "¿Desarchivar esta actividad?",
      activity_unarchive_confirm_text:
        "La actividad volverá al estado de borrador y será de nuevo visible en la lista de actividades en curso.",
      activity_unarchive_success: "La actividad se ha desarchivado correctamente",
      activity_archive_not_draft: "Esta actividad ya no puede archivarse: ya ha sido firmada.",
      activity_end_date_modal_title: "Indicar la fecha de fin",
      activity_end_date_info:
        "Esta fecha indica simplemente que la actividad ha terminado en el tiempo. No abre la certificación ni bloquea el contenido de la actividad.",
      activity_end_date_label: "Fecha de fin",
      activity_end_date_success: "Fecha de fin guardada",
      activity_edit_modal_title: "Modificar una actividad",
      activity_view_modal_title: "Consultar una actividad",
      activity_add_modal_title: "Añadir una actividad",
      activity_history_action: "Historial del seguimiento",
      activity_history_modal_title: "Historial del seguimiento",
      activity_history_empty: "Aún no se ha registrado ningún seguimiento para esta actividad.",
      activity_history_error: "Se ha producido un error al cargar el historial.",
      activity_history_defined_by: "Definido por {name} ({profile}) · {date}",
      activity_comment_label: "Seguimiento de la realización durante este periodo",
      activity_comment_placeholder:
        "Describa lo que ha realizado concretamente en esta actividad durante este periodo.",
      activity_commentaire_missing: "Seguimiento no indicado",
      activity_linked_mission: "Misión: {name}",
      activity_no_mission_linked: "Ninguna misión asociada",
      activity_description_missing: "Descripción no indicada",
      activity_skills_count: "{count} competencia(s) movilizada(s)",
      activity_summary_counts:
        "{ongoing} en curso · {finished} finalizada(s) · {toComplete} por completar · {completed} completa(s) · {archived} archivada(s)",
      activity_summary_counts_without_archived:
        "{ongoing} en curso · {finished} finalizada(s) · {toComplete} por completar · {completed} completa(s)",
      activity_signature_summary_title: "Resumen antes de la validación",
      activity_signature_field_name: "Título",
      activity_signature_field_type: "Tipo",
      activity_signature_field_missions: "Misión(es)",
      activity_signature_field_skills: "Competencias movilizadas",
      activity_signature_missions_more: ({ named }) => `${named("name")} +${named("count")}`,
      activity_signature_warning:
        "Al validar, bloquea el contenido de esta actividad (descripción, análisis, competencias). Se transmitirá a su tutor, que podrá evaluar las competencias movilizadas y añadir un comentario. Esta acción no es reversible por usted mismo.",
      activity_signature_sign_button: "Validar",
      activity_signature_confirm_button: "Guardar y validar",
      activity_signature_confirm_modal_title: "Confirmar la validación",
      activity_signature_incomplete_hint:
        "Las cuatro primeras pestañas deben estar completas antes de poder validar esta actividad.",
      activity_signature_locked_banner: ({ named }) =>
        `Esta actividad ha sido firmada por ${named("name")} el ${named("date")}. Su contenido (descripción, análisis, competencias) está bloqueado.`,
      activity_signature_evaluation_title: "Evaluación de las competencias movilizadas",
      activity_signature_evaluation_optional_badge: "Opcional",
      activity_signature_evaluation_subtitle:
        "Puede evaluar todas, algunas o ninguna de las competencias declaradas por el alternante.",
      activity_signature_certify_button: "Certificar",
      activity_signature_certify_confirm_title: "Confirmar la certificación",
      activity_signature_not_evaluated: "No evaluada",
      activity_signature_level_0: "No implementada",
      activity_signature_level_1: "Iniciada",
      activity_signature_level_2: "Operacional",
      activity_signature_level_3: "Competente",
      activity_signature_level_4: "Experta",
      activity_signature_certifier_comment_label: "Comentario del tutor (opcional)",
      activity_signature_certifier_comment_hint: "Este comentario será visible para el alumno y el resto del trío.",
      activity_signature_certify_warning:
        "La certificación es definitiva. La actividad pasará al estado « Certificada » y el alumno ya no podrá modificarla. Las evaluaciones sin rellenar seguirán como « No evaluadas ».",
      activity_signature_recap_validated_by: ({ named }) => `Firmada por ${named("name")} el ${named("date")}`,
      activity_signature_recap_certified_by: ({ named }) => `Certificada por ${named("name")} el ${named("date")}`,
      activity_signature_info_awaiting_signature: "Pendiente de la firma del alternante.",
      activity_signature_info_awaiting_certification: "Pendiente de evaluación y certificación.",
      activity_signature_info_cancelled: "Esta actividad ha sido archivada.",
      activity_signature_info_default: "Ninguna acción está disponible en esta pestaña por el momento.",
      empty_column: "Título de la columna",
      remove_field_skill: "Eliminación de la competencia asociada",
      field_skill_used: "Esta competencia ya está asociada a esta pregunta",
      remove_field_skill_sub: "¿Seguro que quiere eliminar la asociación de esta competencia con la pregunta?",
      untitled_column: "Columna sin título",
      remove_row_warning: "¿Confirma que quiere eliminar esta línea?",
      remove_column_warning: "¿Confirma que quiere eliminar esta columna?",
      untitled_questionnaire: "Formulario sin título",
      placeholder_description: "Añadir su descripción",
      access_profil: "Perfiles que responden a la pregunta",
      field_skill: "Competencias vinculadas a la pregunta",
      search_skill: "Buscar una competencia",
      opened_question_access: "Acceso a las preguntas abiertas",
      opened_questions: "Preguntas abiertas",
      opened_questions_type: "Tipos de preguntas abiertas",
      grid_title: "Título de la tabla",
      comments_enabled: "Comentarios autorizados",
      comments_label: "Título de los comentarios",
      comments_type: "Tipos de campos comentarios",
      one_line: "Respuesta breve",
      multi_line: "Zona de texto",
      maximal_mark: "Nota máxima",
      mark_scale: "Escala de marca",
      display_mark: "Usar las notas",
      display_radar: "Mostrar el radar",
      question_title: "Título de la pregunta",
      infobulle_content: "Contenido del mensaje informativo",
      question_comment: "Comentario",
      field_type_choose: "Seleccione un tipo",
      short_answer: "Respuesta breve",
      long_answer: "Respuesta larga",
      textarea: "Zona de texto",
      number: "Número",
      dropdown_list: "Lista desplegable",
      unique_choice: "Selección única",
      multiple_choices: "Selección múltiple",
      file: "Archivo",
      date: "Fecha",
      question: ({ plural }) => plural(["pregunta", "preguntas"]),
      date_time: "Fecha y hora",
      remove_question_warning: "¿Confirma que quiere eliminar esta pregunta?",
      option: "Opción",
      untitled_cluster: "Tabla sin título",
      untitled_title: "Título",
      title_label: "Título",
      remove_cluster_warning: "¿Confirma que quiere eliminar esta tabla?",
      value: "Valor",
      choose_option: "Seleccione una opción",
      questionnaire_settings: "Configuración del cuestionario",
      confirm: "Confirmar",
      cancel: "Cancelar",
      rights: "Derechos",
      notes_summary: "Notas y resumen",
      option_placeholder: "Opción",
      value_placeholder: "Nota",
      comment_placeholder: "Añadir un comentario",
      option_settings: "Configuración de opciones",
      columns: "Columnas",
      active: "Activo",
      inactive: "No activo",
      unable: {
        confirmation: "¿Está seguro de que desea activar este cuestionario?",
        success: "¡Cuestionario activado con éxito!",
      },
      disable: {
        confirmation: "¿Está seguro de que desea desactivar este cuestionario?",
        success: "¡Cuestionario desactivado con éxito!",
      },
      global_export_visibility: "Visible en la exportación global del cuaderno",
    },
    category: {
      title: ({ plural }) => plural(["Categoría", "Categorías"]),
      add: "Añadir una categoría",
      delete_with_links: {
        title: "Eliminar una categoría vinculada",
        sub_title:
          "Esta categoría está vinculada a cuestionarios. Debe eliminar estos cuestionarios para poder eliminar la categoría. ¿Realmente desea continuar?",
        success: "¡Categoría vinculada eliminada con éxito!",
      },
    },
    mission: {
      title: ({ plural }) => plural(["Misión", "Misiones"]),
    },
    group: {
      title: ({ plural }) => plural(["Grupo", "Grupos"]),
    },
    training: {
      title: ({ plural }) => plural(["Formación", "Formaciones"]),
      go_to_list: "Acceder a la lista de formaciones",
    },
    webLink: {
      title: ({ plural }) => plural(["Enlace útil", "Enlaces útiles"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promoción", "Promociones"]),
    },
    skill: {
      title: ({ plural }) => plural(["Competencia", "Competencias"]),
      list: {
        title: "Configuración de competencias",
        empty: "Todavía no hay competencias en esta formación. Cree una primera categoría para empezar",
        empty_only: "Todavía no hay competencias introducidas",
      },
      actions: {
        add: "Añadir una competencia",
        module_actions: "Configuración",
        skill_actions: "Gestionar las competencias",
        session_actions: "Gestionar los períodos",
        import_export_actions: "Importar/Exportar",
        reminder_actions: "Recordatorios",
        active_justificative: "Activar las pruebas en todas las competencias",
        active_justificative_title: "Activar las pruebas",
        active_justificative_activate_success: "¡Pruebas de competencias activadas con éxito!",
        active_justificative_unactivate_success: "¡Pruebas desactivadas sobre las habilidades con éxito!",
      },
      name: "Nombre",
      level: "Nivel exigido",
      default: {
        not_acquired: "No adquirida",
        acquired: "Adquirida",
        expert: "Experto",
        being_acquired: "En curso de adquisición",
        insufficient_mastery: "Dominio insuficiente",
        partial_mastery: "Dominio parcial",
        average_mastery: "Dominio medio",
        good_mastery: "Dominio correcto",
        excellent_mastery: "Dominio excelente",
      },
    },
    skill_configuration: {
      title: "Configuración del módulo",
      success: "Configuración actualizada correctamente",
      use_admin: "¿Utilizar la configuración de administrador?",
      warning: "¡Atención! Debe terminar de configurar el módulo de competencias para poder integrar una referencia.",
    },
    skill_referential: {
      title: "Gestión de referencias de competencias",
      success: "Referencias actualizadas correctamente",
      warning: "¡Atención! Debe terminar de configurar el módulo de competencias para poder integrar una referencia.",
      empty_add: "Todavía no hay referencias. Haga clic en + para añadir una",
    },
    skill_generate: {
      title: "Gestionar un cuestionario a partir de las competencias",
      success: "Cuestionario generado correctamente",
    },
    skill_remove: {
      title: "Eliminar la referencia (sin los cuestionarios)",
      sub_title: "¿Confirma que quiere eliminar la referencia?",
      success: "Referencia eliminada correctamente",
    },
    skill_import: {
      title: "Exportar sus competencias",
      success: "Competencias importadas correctamente",
    },
    skill_import_france_competence: {
      title: "Importar la referencia de competencias de Francia",
      confirm: "¿Seguro que quiere cargar la referencia de France Compétences en esta formación?",
      success: "Referencia importada correctamente",
    },
    skill_export: {
      title: "Exportar las competencias",
      success: "Competencias exportadas correctamente",
    },
    skill_export_taught: {
      title: "Exportar las materias",
      success: "Materias exportadas correctamente",
    },
    skillSession: {
      gestion: "Gestión de períodos de competencias",
      list: {
        title: "Configuración de períodos",
        empty: "Todavía no hay ningún periodo. Haga clic en + para añadir uno",
      },
      title: ({ plural }) => plural(["Periodo", "Períodos"]),
    },
    skillReferential: {
      title: ({ plural }) => plural(["Referencia", "Referencias"]),
      use: "Utilizar una referencia",
      empty: "Todavía no hay ninguna referencia vinculada a este periodo, haga clic en el + para vincular una",
    },
    skillCategory: {
      title: ({ plural }) => plural(["Categoría", "Categorías"]),
    },
    skin: {
      title: ({ plural }) => plural(["Diseño", "Diseños"]),
      list: {
        title: "Diseño",
      },
    },
    termination_prevention: {
      title: "Seguimiento y prevención de rupturas",
    },
    gradebook: {
      title: ({ plural }) => plural(["Boletín de notas", "Boletines de notas"]),
      global_config: "Encabezado y pie de página",
      session_config: "Configuración de períodos",
      exam_type: "Lista de tipos de exámenes",
      start_date: "Fecha de apertura: ",
      end_date: "Fecha de cierre: ",
      empty_session: "No hay ningún periodo disponible por el momento, añada uno.",
      empty_subject: "No hay ningún tema registrado para este periodo, por favor añada uno.",
      empty_exam:
        "No hay ningún examen registrado para esta asignatura. Seleccione uno en la configuración de la asignatura haciendo clic aquí.",
      delete_session: {
        confirmation: "¿Está seguro de que desea eliminar este periodo?",
        success: "¡Período eliminado correctamente!",
      },
      delete_subject: {
        confirmation: "¿Estás seguro de que deseas eliminar esta asignatura de la sesión?",
        success: "¡Asignatura eliminada correctamente!",
      },
      delete_exam: {
        confirmation: "¿Está seguro de que desea eliminar esta revisión?",
        success: "¡Examen aprobado con éxito!",
      },
      scale: "Barem",
      set_exam_and_coef: "Indique el tipo de examen y el coeficiente para esta asignatura",
    },
    exam: {
      title: ({ plural }) => plural(["Examen", "Exámenes"]),
      type_title: "Tipo de examen",
    },
    triad: {
      title: ({ plural }) => plural(["Trinomio", "Trinomios"]),
      list: {
        name: "Nombre",
        apprentice_name: "Nombre del alumno",
        tutor_name: "Nombre del tutor pedagógico",
        map_name: "Nombre del tutor de empresa",
        gestionnary_name: "Nombre del gestor",
      },
      registration: {
        contract_link_title: ({ named }) => "Ver el contrato" + (named("code") ? ": " + named("code") : ""),
        link_title: ({ named }) => "Ver la ficha de inscripción" + (named("code") ? " : " + named("code") : ""),
        reference: ({ named }) => "Inscripción vinculada" + (named("code") ? " : " + named("code") : ""),
      },
      tutor: {
        title: ({ plural }) => plural(["Tutor pedagógico", "Tutores pedagógicos"]),
      },
      map: {
        title: ({ plural }) => plural(["Tutor de empresa", "Tutores de empresa"]),
      },
      questionnaire_triad_already_signed: "Atención: hay firmas de \ncuestionarios asociadas \na este trinomio",
      usurp: {
        title: "Representar a",
      },
      login: {
        title: "Gestionar el envío de identificadores",
      },
      delete_all: {
        tutor: "Eliminar todos los tutores pedagógicos",
        map: "Eliminar todos los tutores de empresa",
      },
      delete: {
        tutor: "Eliminar este tutor pedagógico",
        map: "Eliminar este tutor de empresa",
        legal_responsible: "Eliminar este responsable legal",
      },
      delete_member: {
        title: "Miembro del trinomio",
      },
      delete_all_tutor: {
        title: "todos los tutores pedagógicos",
      },
      delete_all_map: {
        title: "todos los tutores de empresa",
      },
      edit: {
        legal_responsible: "Modificar este responsable legal",
        tutor: "Modificar este tutor pedagógico",
      },
      contract: {
        title: "Gestión de contratos",
      },
      complete: {
        title: "Añadir un miembro al trinomio",
      },
      actions: {
        title: "Acciones",
      },
      add_test: "Trinomio de prueba",
      add_test_success: "Trinomio de prueba añadido correctamente",
      send_user_infos: "Gestionar el envío de identificadores",
      send_welcome_email: "Enviar el correo electrónico de bienvenida con las credenciales",
      send_welcome_email_success: "Correo(s) de bienvenida enviado(s) correctamente",
      reset_password: "Restablecer la contraseña y volver a enviar el identificador",
      reset_password_success: "Correo(s) de restablecimiento de contraseña enviado(s) correctamente",
      activate_livret: "Activar el cuaderno",
      deactivate_livret: "Desactivar el cuaderno",
      livret_active_badge: "Cuaderno activo",
      livret_inactive_badge: "Cuaderno no activado",
      send_user_infos_message:
        "Seleccione los usuarios y haga clic en el tipo de correo electrónico que les quiere enviar.",
      add_secondary_user: "Añadir un usuario secundario para este trinomio",
      add_secondary_user_success: "Usuario secundario añadido correctamente",
      remove_secondary_user: "Usuario secundario eliminado correctamente",
    },
    studeaUser: {
      title: ({ plural }) => plural(["Usuario", "Usuarios"]),
    },
    user: {
      title: ({ plural }) => plural(["Usuario", "Usuarios"]),
    },
    crew: {
      title: ({ plural }) => plural(["Grupo", "Grupos"]),
      cannot_remove: "No puede eliminar un grupo que tenga trinomios",
    },
    contract: {
      title: ({ plural }) => plural(["Contrato", "Contratos"]),
      empty: "Este trinomio no tiene ningún contrato",
      number: "Contrato n.º",
      dates: "Fechas del contrato",
      company: "Empresa",
      duration: "Duración",
      address: "Dirección",
      map: "Mentor",
      manager: "Gestor",
      contrat_type: "Tipo de contrato",
      rupture_date: "Fecha de rescisión del contrato",
      contract_rupture_date: "Contrato rescindido en: ",
      dropped_out: "Abandonó el: ",
      rupture_reason: "Motivo de la rescisión del contrato",
      rupture_reason_text: "Comentario",
      months: "meses",
      also_tutor: "Es tutor de este trinomio",
      incident_sheet: "Hay una alerta en curso en este trinomio",
      no_current_access: "Ya no tiene acceso a este trinomio: un contrato más reciente lo ha reemplazado",
    },
    template: {
      title: ({ plural }) => plural(["Plantilla", "Plantillas"]),
    },
    lesson: {
      title: ({ plural }) => plural(["Curso", "Curso"]),
    },
    skillType: {
      title: ({ plural }) => plural(["Tipo de competencia", "Tipos de competencias", "Tipo de competencias"]),
    },
    subject: {
      title: ({ plural }) => plural(["Asignatura", "Asignaturas"]),
      former: {
        add: "Añadir un formador",
        add_new: "Añadir un formador que no está en la lista",
        is_former: "Este usuario ya es formador.",
        is_studea_manager:
          "Este usuario es responsable del folleto, asignarle una nueva función podría cambiar estos derechos.",
        is_admin: "Este usuario es administrador, se le añadirá un perfil encargado de cuaderno de formador.",
        empty:
          "No se ha encontrado ningún usuario. Introduzca el correo electrónico, el nombre y los apellidos para crear un nuevo formador.",
        add_success: "Formador añadido correctamente",
      },
    },
    unit: {
      title: ({ plural }) => plural(["Unidad", "Unidades"]),
    },
    planning: {
      title: ({ plural }) => plural(["Evento", "Eventos"]),
      removeSelected: {
        title: "Eliminar los eventos seleccionados",
        sub_title: "¿Confirma que quiere eliminar estos eventos?",
        sucess: "Eventos eliminados correctamente",
      },
      end_of_recurrence: "Fin de la recurrencia:",
    },
    trainingCourseModuleTriad: {
      title: ({ plural }) => plural(["Módulo", "Módulos"]),
    },
    absence: {
      title: ({ plural }) => plural(["Ausente", "Ausencias"]),
      list: {
        title: "Asistencia",
      },
      config: {
        title: "Configuración",
        success: "Configuración modificada correctamente",
      },
      export: {
        full_list: "Lista completa de ausencias",
        apprentice_list: "Lista de ausencias por ",
        excel: "(Excel)",
        pdf: "(PDF)",
        state: "Estado de las ausencias (planificación)",
      },
      attestation: {
        title: "Publicación de certificado de asistencia",
      },
    },
    module: {
      title: ({ plural }) => plural(["Módulo", "Módulos"]),
      active: {
        success: "Módulo activado correctamente",
      },
      unactive: {
        success: "Módulo desactivado correctamente",
      },
    },
    registration: {
      title: ({ plural }) => plural(["Inscripción", "Inscripciones"]),
      list: {
        title: "Inscripciones",
      },
      go_to: "Ir a inscripciones",
    },
    matching: {
      go_to: "Ir a emparejamiento",
    },
    notepad: {
      title: ({ plural }) => plural(["Bloc de notas", "Blocs-notas"]),
    },
    note: {
      title: ({ plural }) => plural(["Nota", "Notas"]),
    },
    document: {
      title: ({ plural }) => plural(["Documento", "Documentos"]),
      pedagogic_documents: "Documentos pedagógicos",
      general_documents: "Documentos generales",
      shared_documents: "Documentos compartidos",
      shared_document_add: "Añadir documento compartido",
      shared_document_edit: "Modificar un documento compartido",
      shared_document_list: "Documentos compartidos",
      shared_document_info:
        "Este documento está compartido. Para modificarlo, \nvaya a la lista de documentos compartidos",
      trainingCourse_documents: "Documentos de la promoción",
      error_file_or_link: "Agregue un archivo o ingrese un enlace",
      link: "enlace",
    },
    "document/shared": {
      title: ({ plural }) => plural(["Documento compartido", "Documentos compartidos"]),
    },
    incident_sheet: {
      title: ({ plural }) => plural(["Alerta", "Alertas"]),
      list: "Alertas",
      add_comment: "Añadir un comentario",
      close: "Cerrar",
      close_confirmation: "¿Seguro que quiere cerrar esta alerta?",
      open: "Abrir",
      open_confirmation: "¿Seguro que quiere reabrir esta alerta?",
      delete: "Eliminar",
      delete_confirmation: "¿Seguro que quiere eliminar esta alerta?",
      in_progress: "En curso",
      closed: "Cerrado",
      search: "Buscar una alerta",
      see_sheet: "Ver la alerta",
      see_questionnaire: "Ver el cuestionario",
      comment: "Comentario",
      status: "Estado",
      no_status: "Sin estado",
    },
    currently: "actualmente",
    documentExchange: {
      list: {
        title: "Intercambio de documentos",
      },
    },
    messaging: {
      list: {
        title: "Mensajes",
      },
    },
    dashboard: {
      list: {
        title: "Tablero de control",
      },
      please_use_filter_to_see_data: "Utilice los filtros para poder visualizar los datos.",
      signature_cancel_confirmation: "¿Confirma que quiere cancelar la firma?",
      filter: "Filtrar",
      delete_filters: "Eliminar los filtros",
      questionnaire: {
        unlocked_confirmation: "¿Quiere desbloquear este cuestionario?",
        locked_confirmation: "¿Quiere bloquear este cuestionario?",
        unlocked_all_confirmation: "¿Quiere desbloquear todos los cuestionarios de esta columna?",
        unlock_all_questionnaires: "Desbloquear todos los cuestionarios de esta columna",
        unlock_questionnaire: "Desbloquear este cuestionario",
        opening_date_on: "Fecha de inscripción en",
        lock_questionnaire: "Bloquear este cuestionario",
        cancel_signature: "Anular esta firma",
        send_email_reminder: "Recordar por correo electrónico",
        send_email_reminder_confirmation: "¿Seguro que quiere enviar un recordatorio por correo electrónico?",
        send_email_reminder_success: "Correo electrónico enviado correctamente",
        send_email_reminder_no_mail:
          "No se ha enviado ningún recordatorio: las condiciones aún no se cumplen (no todos los encuestados han firmado).",
        success_all_unlock: "Cuestionarios desbloqueados correctamente",
        success_unlock: "Cuestionario desbloqueado correctamente",
        success_lock: "Cuestionario bloqueado correctamente",
        success_cancel_signature: "Firma anulada correctamente",
        delete_category_confirmation: "Tenga en cuenta que los cuestionarios de esta categoría se eliminarán.",
        to_much_data: "Demasiados datos seleccionados, refine su búsqueda.",
        table_lock: "Bloquear los cuestionarios",
        table_unlock: "No bloquear cuestionarios",
      },
      mail_relance: {
        title: "Recordatorio por correo electrónico",
        subtitle: "Los recordatorios no se enviarán a los cuestionarios bloqueados (candado cerrado)",
      },
      email_reminder: "Recordar por correo electrónico",
      export: {
        title: "Exportar",
        all_promotion_replies: "Exportar todas las respuestas de la promoción",
        all_promotion_replies_to_excel: "Exportar todas las respuestas de la promoción en formato Excel.",
        visit_date: "Exportar las fechas de visita a la empresa",
        dashboard_excel: "Exportar el panel de control en formato Excel",
        questionnaires_pdf: "Exportar los cuestionarios",
      },
      roles: {
        alternate: "Alumno en prácticas",
        educational_tutor: "Tutor pedagógico",
        company_tutor: "Tutor de empresa",
        lea_manager: "Responsable de léa",
      },
      got_to_questionnaire: "Acceder al cuestionario",
      go_to_questionnaire: "Ir al cuestionario",
    },
    gradeBookDashboard: {
      list: {
        title: "Tablero de notas",
      },
      export_dashboard_excel: "Exportar tabla de notas en formato Excel",
      caption: {
        danger: "Nota entre la nota mínima y el promedio inferior",
        success: "Nota entre el promedio superior y la nota máxima",
      },
    },
    terminationPreventionDashboard: {
      list: {
        title: "Seguimiento y prevención de rescisiones",
      },
      caption: "Seguimiento y prevención de rescisiones, alumnos en alternancia agrupados por grupo",
      empty: "Ningún alumno en alternancia coincide con su búsqueda.",
      filter_title: "Estado",
      count: ({ plural, named }) => plural([`${named("count")} alumno`, `${named("count")} alumnos`]),
      count_filtered: ({ named }) => `${named("visible")} de ${named("total")} alumnos`,
      weather: {
        title: ({ named }) => `Historial del clima de: ${named("apprentice")}`,
        empty: "Ninguna lectura del clima para este alumno",
        author_deleted: "Autor eliminado",
        concern_reasons: "Motivos de preocupación",
      },
    },
    skillDashboard: {
      list: {
        title: "Tablero de control de competencias",
      },
      export_dashboard_excel: "Exportar tabla de competencias en formato Excel",
      skill: {
        acquired: "Adquirida",
        in_progress: "En curso",
        not_acquired: "No adquirida",
      },
    },
    export: {
      list: {
        title: "Exportaciones",
      },
    },
    mail: {
      list: {
        title: "Seguimiento de correos",
        empty: "Ningún correo ha sido enviado",
      },
      view: "Ver el contenido del correo",
      data: "Dato del correo",
    },
    history: {
      list: {
        title: "Historial de conexiones",
      },
    },
    assiduite: "Gestión de asistencia",
    subscriptions_dashboard: "Tablero de control de inscripciones",
    import: {
      modele: "Modelo de archivo para descargar",
      defaultModele: "Plantilla del archivo que se va a descargar (plantilla predeterminada)",
      triad_new_file:
        "Atención: hay disponible un nuevo modelo desde 18/09/2023.\n" +
        "          Descárguelo y úselo para cargar sus trinomios.",
      triad_update:
        "Solo se actualizarán los miembros que no tengan trinomio. No se actualizará ningún dato (apellido, nombre o e-mail) de un usuario existente.",
      thanks: "No modifique ni elimine las columnas del modelo",
    },
    download_file_here: "Descargar el archivo AQUÍ",
    session: {
      from: "Del",
      to: "al",
      title: ({ plural }) => plural(["Período", "Períodos"]),
    },
    user_never_connected: "Este usuario no se ha conectado nunca",
    welcome_mail_send: ({ named }) => `Correo de bienvenida enviado ${named("number")} veces`,
    reset_password_mail_send: ({ named }) => `Correo de restablecimiento enviado ${named("number")} veces`,
    see_last_mail_content: "Ver el contenido del último correo electrónico enviado",
    duplication: "Duplicación de datos",
    duplication_historic: "Historial de duplicaciones",
    search_duplication: "Buscar duplicados",
    see_duplication: "Ver toda la información sobre esta duplicación",
    duplication_date: "Fecha de finalización",
    duplication_too_old: "No se puede reiniciar una duplicación que tenga más de 15 días.",
    duplciation_status: {
      pending: "En proceso",
      done: "Terminado",
      failed: "Varados",
    },
    duplication_status: {
      pending: "En proceso",
      done: "Terminado",
      failed: "Fallido",
    },
    reload_duplication: {
      title: "Relanzar esta duplicación",
      confirmation: "¿Estás seguro de que quieres relanzar esta duplicación?",
    },
    details: "Detalles",
    status: "estado",
    statistic: {
      title: ({ plural }) => plural(["Estadística", "Estadísticas"]),
      shared_documents: "Trinomios incompletos",
      calculation_in_progress: "Cálculo de los indicadores en curso.",
      calculation_refresh: "Por favor, espere un momento o actualice la página para actualizar el cálculo.",
    },
    driver_licence: {
      title: "Permis b",
      requests: "Demandes d'aide au permis B",
      list: "Liste des demandes d'aide au permis B",
      valid: "Valider la demande d'aide",
      valid_confirmation: "Êtes-vous sur de vouloir valider cette demande ?",
      export: "Exporter la liste des demandes d'aide",
      edit: "Modifier la demande de : ",
      overview: "Aperçu de la demande de : ",
      request_edit: {
        success: "Demande d'aide au permis B modifié avec succès",
      },
    },
    duplicated: {
      relaunch: "Relanzar",
      reference: "Referencia",
      destination: "Destino",
      type: "Tipo de duplicado",
      confirmation: "¿Estás seguro de que quieres duplicar estos datos?",
      action: {
        replace: "Sustituir",
        add: "Añadir",
        crush: "Aplastar",
        options: {
          title: "Opciones",
          add_to_current_year: "Añadir al año en curso",
          empty_training_course: "Únicamente en promociones vacías",
          add_to_due_date: "Añadir un año a las fechas de vencimiento",
          overwrite_current_year_only: "Sobrescribir sólo el año en curso",
        },
      },
      questionnaire: {
        already_sign_not_affected: "Los cuestionarios ya firmados no se verán afectados",
        copy_even_if_already_existing: "Los cuestionarios se copiarán aunque ya existan",
        replace_questionnaire_with_same_name_questionnaire:
          "Los cuestionarios con el <strong>mismo nombre</strong> serán sustituidos.",
        replace_all: "Se eliminarán los cuestionarios existentes",
      },
      transition_report: {
        title: "Promociones no procesadas",
        destination: "Destino",
        questionnaire_count: ({ plural }) => plural(["cuestionario", "cuestionarios"]),
        status_resolved: "Procesada",
        status_blocked: "Bloqueada",
        status_skipped: "Ignorada",
        status_would_create: "Promoción por crear",
        step_same_training: "Misma formación",
        step_code_formation_acronym: "Código de formación + acrónimo",
        step_code_formation_name: "Código de formación + nombre",
        step_code_formation_year_number: "Código de formación + año",
      },
      training_course: {
        duplicated_data: "Datos duplicados",
        add_data_if_empty: "Añade datos si no existen",
        duplicate_choice: "Desea duplicar",
        duplicate_from_reference: "Permite copiar un folleto estándar en un paquete de promoción",
        duplicate_from_year: "Permite añadir un nuevo año duplicando la configuración del año anterior.",
      },
    },
    trainingPeriod: {
      title: ({ plural }) => plural(["Semestre", "Semestres"]),
    },
    file: {
      title: ({ plural }) => plural(["Archivo", "Archivos"]),
    },
    institution: {
      title: ({ plural }) => plural(["Establecimiento", "Establecimientos"]),
    },
    component: {
      title: ({ plural }) => plural(["Componente", "Componentes"]),
    },
    livretConfig: {
      title: "Activación del cuaderno",
    },
  },
  add_session: "Añadir un periodo",
  edusign: {
    title: "Edusign",
    synchronize: {
      title: "Iniciar la sincronización en Edusign",
      confirmation: "¿Está seguro de que desea iniciar la sincronización en Edusign?",
    },
    get_data: {
      title: "Recuperar las ausencias y presencias",
      confirmation: "¿Está seguro de que desea recuperar las ausencias y presencias de Edusign?",
    },
    reset: {
      title: "Restablecer asistencia y ausencias",
      confirmation: "¿Estás seguro de que deseas eliminar asistencias y ausencias de horarios no validados?",
    },
  },
  uniservice: {
    title: "Uniservice",
    get_data: {
      title: "Recuperar asistencias",
      confirmation: "¿Estás seguro de que quieres recuperar las asistencias de Uniservice?",
    },
    reset: {
      title: "Restablecer asistencias y ausencias",
      confirmation: "¿Está seguro de que desea eliminar las asistencias y ausencias de los horarios no validados?",
    },
  },
};
